import {
  facetsContain,
  type Filter,
  type Prompt,
} from "@1js/pl-card-components";
import * as React from "react";
import { ShowMore } from "../AllPrompts/ShowMore.web";
import {
  BookmarkPromptCards,
  type BookmarkPromptCardsProps,
} from "./BookmarkPromptCards";
import { SectionHeader } from "./SectionHeader";

export type PromptsSectionProps = BookmarkPromptCardsProps & {
  seeAllFilter: Record<string, string[]>;
  allFilteredPrompts: Prompt[];
  collapsedViewPromptsCount: number;
  headerTitle: string;
  headerIcon: React.ReactElement;
  isShowHasMore: boolean;
  hasMore?: boolean;
  isLoading: boolean;
  handleCardFocus: () => void;
  onMoreClicked: () => void;
  selectedFacets: Record<string, string[]>;
  filters: Filter[];
  handleFilterChange: (
    selectedValues: Record<string, string[]>,
    filters: Filter[]
  ) => void;
};

export const PromptsSection: React.FC<PromptsSectionProps> = ({
  seeAllFilter,
  allFilteredPrompts,
  collapsedViewPromptsCount,
  headerTitle,
  headerIcon,
  prompts,
  resultsAnnouncementId,
  promptsToDisplay,
  setLastFocusedPromptId,
  setCurrentFocusedPromptId,
  promptRefs,
  currentFocusedPromptId,
  isWorkgroupPublishingEnabled,
  shareToWorkgroup,
  handleShareViaCopyLinkClicked,
  handleShareViaEmailClicked,
  handleCardClick,
  onPromptBookmarkToggled,
  onDelete,
  groups,
  handlePromptsTabSelected,
  onBookmarkToggled,
  setDialogOpen,
  isShowHasMore,
  hasMore,
  isLoading,
  handleCardFocus,
  onMoreClicked,
  selectedFacets,
  filters,
  handleFilterChange,
}) => {
  const isDetailedViewEnabled = facetsContain(seeAllFilter, selectedFacets);

  if (allFilteredPrompts.length === 0) {
    return null;
  }

  return (
    <>
      <SectionHeader
        title={headerTitle}
        icon={headerIcon}
        selectedFacets={selectedFacets}
        filters={filters}
        handleFilterChange={handleFilterChange}
        seeAllFilter={seeAllFilter}
        isSeeAllButtonEnabled={
          allFilteredPrompts.length > collapsedViewPromptsCount
        }
      />
      <BookmarkPromptCards
        prompts={prompts}
        resultsAnnouncementId={resultsAnnouncementId}
        promptsToDisplay={
          isDetailedViewEnabled
            ? promptsToDisplay
            : allFilteredPrompts.slice(0, collapsedViewPromptsCount)
        }
        setLastFocusedPromptId={setLastFocusedPromptId}
        setCurrentFocusedPromptId={setCurrentFocusedPromptId}
        promptRefs={promptRefs}
        currentFocusedPromptId={currentFocusedPromptId}
        isWorkgroupPublishingEnabled={isWorkgroupPublishingEnabled}
        shareToWorkgroup={shareToWorkgroup}
        handleShareViaCopyLinkClicked={handleShareViaCopyLinkClicked}
        handleShareViaEmailClicked={handleShareViaEmailClicked}
        handleCardClick={handleCardClick}
        onPromptBookmarkToggled={onPromptBookmarkToggled}
        onDelete={onDelete}
        groups={groups}
        handlePromptsTabSelected={handlePromptsTabSelected}
        onBookmarkToggled={onBookmarkToggled}
        setDialogOpen={setDialogOpen}
      />
      {isDetailedViewEnabled && (
        <ShowMore
          isShowHasMore={isShowHasMore}
          hasMore={hasMore}
          isLoading={isLoading}
          handleCardFocus={handleCardFocus}
          onMoreClicked={onMoreClicked}
        />
      )}
    </>
  );
};
